import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import Customers from "@/pages/Customers";
import Templates from "@/pages/Templates";
import Reports from "@/pages/Reports";
import Administration from "@/pages/Administration";
import CreateProjectWizard from "@/pages/CreateProjectWizard";
import { ProjectLayout } from "@/pages/project/ProjectLayout";
import Overview from "@/pages/project/Overview";
import Discovery from "@/pages/project/Discovery";
import GuidedModule from "@/pages/project/GuidedModule";
import Documents from "@/pages/project/Documents";
import Review from "@/pages/project/Review";
import Blueprint from "@/pages/project/Blueprint";
import Backlog from "@/pages/project/Backlog";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="flex min-h-screen items-center justify-center bg-background text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ChangePassword />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="projects" element={<Projects />} />
              <Route path="projects/new" element={<CreateProjectWizard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="templates" element={<Templates />} />
              <Route path="reports" element={<Reports />} />
              <Route path="administration" element={<Administration />} />
              <Route path="projects/:id" element={<ProjectLayout />}>
                <Route index element={<Navigate to="overview" replace />} />
                <Route path="overview" element={<Overview />} />
                <Route path="discovery" element={<Discovery />} />
                <Route path="discovery/:moduleKey" element={<GuidedModule />} />
                <Route path="documents" element={<Documents />} />
                <Route path="review" element={<Review />} />
                <Route path="blueprint" element={<Blueprint />} />
                <Route path="backlog" element={<Backlog />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
